import React, { useState, useEffect } from 'react';
import './TauriExportTable.css';

const TauriExportTable = ({ exportList, selectedExportList }) => {
  const [selectedVisuals, setSelectedVisuals] = useState([]);


  useEffect(() => {
    if (exportList) {
      const initialSelectedVisuals = exportList.map(visual => visual.visual.title);
      setSelectedVisuals(initialSelectedVisuals);
      selectedExportList(getSelectedEndpointsAndParameters(initialSelectedVisuals));
    }
  }, [exportList, selectedExportList]);

  const handleCheckboxChange = (title) => {
    setSelectedVisuals((prevSelected) => {
      const newSelected = prevSelected.includes(title)
        ? prevSelected.filter((visualId) => visualId !== title)
        : [...prevSelected, title];
      selectedExportList(getSelectedEndpointsAndParameters(newSelected));
      return newSelected;
    });
  };

  const getSelectedEndpointsAndParameters = (titles) => {
    return exportList
      .filter(visual => titles.includes(visual.visual.title))
      .map(visual => ({
        "id": visual.visual.binding.data.endpoint,
        "params": visual.visual.binding.data.parameters
      }));
  };

  if (!exportList) {
    return null; // Return null if exportList is null or undefined
  }

  return (
    <div className='tauri-exportdialog-container'>
      {exportList.map((visual, index) => (
        <div key={index} className='tauri-exportdialog-row'>
          <div className='tauri-exportdialog-cell'>
            <input
              type="checkbox"
              className="circle-checkbox"
              checked={selectedVisuals.includes(visual.visual.title)}
              onChange={() => handleCheckboxChange(visual.visual.title)}
            />
          </div>
          <div className='tauri-exportdialog-cell'>
            {visual.visual.title}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TauriExportTable;
